
import ConnectAPI from "../../../services/api";
import React, { useState, useEffect } from "react";
import { authenticationService } from "../../../services/context/AuthService";
import { Table, Button, Tabs } from "@veneer/core";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import axios from 'axios';
import $ from 'jquery';

function SpecialConditionLetter(props) {
    //by Jocks
    const connectApi = new ConnectAPI();
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const [customerName, setCustomerName] = useState("");
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    
    const selectTab = (event) => (index) => {
        clear();
        setactiveTabIndex(index);
    };

    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate = false;
        currentUser.urls.forEach( ur => {
            if ( ur == window.location.pathname ) validate=true;
        });
        if (validate==false){
            const { history } = props;
            history.push({ pathname: '/' });
        }//end validate
        fetchData();
    }, []);

    const getSCdataCallback = (status, data) => {
        setTableData(data.filteredApprovalLevel);
        setIsLoading(false);
    }

    let email = authenticationService.currentUserValue.email
    const fetchData = async () => {
        connectApi.getWithParams("api/Channels/specialConditionsAll", email, getSCdataCallback)
        .catch ((error) => {
            setIsLoading(false);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
        setIsLoading(true);
    }

    function newtab(File, idButtom){
        axios({
            url: 'api/resources/GetFile', 
            method: 'POST', 
            responseType: 'blob', 
            data: { fileName: File }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const buttonId = document.getElementById(idButtom);
            buttonId.src = url;
        }).catch((error) => {
            Swal.fire( 'Error ' + error.response?.status,
              error.response?.data, 'error'
            );
            return;
        });
    }

    function clear(){
        const buttonId1 = document.getElementById("iframeUrlHP");
        buttonId1.src = "";
        const buttonId2 = document.getElementById("iframeUrl");
        buttonId2.src = "";
        setTitleShow(true);
    }

    const handleActivate = (e, status, iframeHPId, iframeCustomerId = null) => {
        clearIframes([iframeHPId, iframeCustomerId]);

        const id = $(e.target).closest('tr').children().eq(0).text();
        if (!id || id === "Special Condition") return;
        const sc = tableData.find(sc => sc.idSpecialCondition == id);
        if (!sc || !sc.idSpecialCondition) return;

        const baseFileName = `${sc.idSpecialCondition}-${sc.idCustomer}-${sc.idEndUser}`;
        const nameHP = `LetterCreateiPSP\\${baseFileName}.pdf`;
        newtab(nameHP, iframeHPId);
        if (iframeCustomerId) {
            const nameC = `LetterUpdateChanel\\${baseFileName}.pdf`;
            newtab(nameC, iframeCustomerId);
        }

        setCustomerName(sc.customerName);
        setTitleShow(false);
    };

    const clearIframes = (ids) => {
        ids.filter(Boolean).forEach(id => {
            const iframe = document.getElementById(id);
            if (iframe) iframe.src = "";
        });
    };

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy == t('specialcondition.startdate') || orderBy == t('specialcondition.enddate') ){
            if (Date.parse(bSort) < Date.parse(aSort)) return -1;
            if (Date.parse(bSort) > Date.parse(aSort)) return 1;
        } else {
            if (bSort < aSort) return -1;
            if (bSort > aSort) return 1;
        }
        return 0;
    }
    function filterSort(array, orderBy, orderType) {
        return array.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    const [pageSize] = useState(10);
    const [pages, setPages] = useState({
        active: 1,
        inactive: 1,
        expired: 1,
        rejected: 1,
    });
    const handlePageChange = (tabKey) => (page) => {
        setPages( prev => ({ ...prev, [tabKey]: page }) );
    };

    const [titleShow, setTitleShow] = useState(true);
    const [orderBy, setOrderBy] = useState(t('Special Condition'));
    const [orderType, setOrderType] = useState("descending");

    const getPagedData = (statusKey, page) => {
        const filtered = tableData.filter(x => x.status === statusKey);
        const sorted = filterSort(filtered, orderBy, orderType);
        const paged = sorted.slice((page - 1) * pageSize, page * pageSize);
        return { data: paged, totalItems: filtered.length };
    };
    const { data: activeData, totalItems: activeTotal } = getPagedData('Active', pages.active);
    const { data: inactiveData, totalItems: inactiveTotal } = getPagedData('Standby', pages.inactive);
    const { data: expiredData, totalItems: expiredTotal } = getPagedData('InActive', pages.expired);
    const { data: rejectedData, totalItems: rejectedTotal } = getPagedData('Rejected', pages.rejected);

    const handleSort = (_, { id, type }) => { setOrderBy(id); setOrderType(type); };

    function SpecialConditionTab({
        data,
        currentPage,
        onPageChange,
        titleShow,
        customerName,
        handleRowClick,
        iframeIdHP,
        iframeIdCustomer,
        t,
        orderBy,
        orderType,
        pageSize,
        totalItems
    }) {
        return (
            <>
                <Table
                    onClick={handleRowClick}
                    columns={[
                        { id: 'idSpecialCondition', label: t('Special Condition') },
                        { id: 'specialConditionType', label: t('Special Condition Type') },
                        { id: 'customerName', label: t('customerName') },
                        { id: 'endUserName', label: t('endUserName') },
                        { id: 'startDate', label: t('specialcondition.startdate') },
                        { id: 'endDate', label: t('specialcondition.enddate') },
                        { id: 'idPress', label: t('pressid') },
                    ]}
                    data={data}
                    loading={isLoading}
                    showFilters
                    onSort={(e, { id, type }) => {
                        handleSort(e, { id, type });
                    }}
                    preferences={{
                        sortBy: { id: orderBy, type: orderType }
                    }}
                    pagination={{
                        currentPage,
                        onPageChange,
                        pageSize,
                        totalItems
                    }}
                />
                <br />
                <Button hidden={titleShow} onClick={() => {clear()}}>Clear</Button>
                <br />
                <div style={{ width: '520px', height: '820px', marginLeft: '20px', textAlign: "center" }}>
                    <h6 hidden={titleShow}>{t('LetterFrom')} HP</h6>
                    <iframe
                        id={iframeIdHP}
                        src=""
                        style={{ width: '500px', height: '800px' }}
                        title="PDF Viewer"
                    />
                </div>
                {iframeIdCustomer && (
                    <div style={{ width: '500px', height: '820px', position: 'absolute', margin: '-820px 0 0 600px', textAlign: "center" }}>
                        <h6 hidden={titleShow}>{t('LetterFrom')} {customerName}</h6>
                        <iframe
                            id={iframeIdCustomer}
                            src=""
                            style={{ width: '500px', height: '800px' }}
                            title="PDF Viewer"
                        />
                    </div>
                )}
            </>
        );
    }

    const tabsConfig = [{
            id: 0,
            label: t("active"),
            data: activeData,
            totalItems: activeTotal,
            currentPage: pages.active,
            onPageChange: handlePageChange('active'),
            onClick: (e) => handleActivate(e, 'active', 'iframeUrlHP', 'iframeUrl'),
            iframeHP: "iframeUrlHP",
            iframeCustomer: "iframeUrl"
        },{
            id: 1,
            label: t("inactive"),
            data: inactiveData,
            totalItems: inactiveTotal,
            currentPage: pages.inactive,
            onPageChange: handlePageChange('inactive'),
            onClick: (e) => handleActivate(e, 'inactive', 'iframeUrlHPInActive', 'iframeUrlInActive'),
            iframeHP: "iframeUrlHPInActive",
            iframeCustomer: "iframeUrlInActive"
        },{
            id: 2,
            label: t("expired"),
            data: expiredData,
            totalItems: expiredTotal,
            currentPage: pages.expired,
            onPageChange: handlePageChange('expired'),
            onClick: (e) => handleActivate(e, 'expired', 'iframeUrlHPExpired', 'iframeUrlExpired'),
            iframeHP: "iframeUrlHPExpired",
            iframeCustomer: "iframeUrlExpired"
        },{
            id: 3,
            label: t("Rejected"),
            data: rejectedData,
            totalItems: rejectedTotal,
            currentPage: pages.rejected,
            onPageChange: handlePageChange('rejected'),
            onClick: (e) => handleActivate(e, 'rejected', 'iframeUrlHPReject'),
            iframeHP: "iframeUrlHPReject",
            iframeCustomer: null
        }
    ];
    let list = tabsConfig.map(tab => ({
        id: tab.id,
        label: tab.label,
        content: (
            <div style={{ padding: '30px' }}>
                <SpecialConditionTab
                    data={tab.data}
                    currentPage={tab.currentPage}
                    onPageChange={tab.onPageChange}
                    titleShow={titleShow}
                    customerName={customerName}
                    handleRowClick={tab.onClick}
                    iframeIdHP={tab.iframeHP}
                    iframeIdCustomer={tab.iframeCustomer}
                    t={t}
                    orderBy={orderBy}
                    orderType={orderType}
                    pageSize={pageSize}
                    totalItems={tab.totalItems}
                />
            </div>
        )
    }));
    return(<>
        <Tabs
            controlId="default"
            onChangeTab={selectTab()}
            selectedTabId={activeTabIndex}
            tabs={list}
        />
    </>);
}

export default SpecialConditionLetter;